// BMP-HOOK-START:recently-viewed
// Product pages: remember viewed product handles (localStorage 'bmp:rv', newest first, max 12) and render the
// "Still eyeing these?" row from /products/<handle>.js, excluding the current product. Hidden when empty.
// The same list is blended into the cart drawer's "Pairs great with" (assets/bmp-cart-upsell.js).
(() => {
  const KEY = 'bmp:rv';
  const MAX_STORED = 12;
  const MAX_SHOWN = 8;

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h) : [];
    } catch { return []; }
  };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch {} };

  const money = (cents) => `$${(Number(cents) / 100).toFixed(2)}`;
  const sized = (src, w) => {
    if (!src) return '';
    const u = String(src).startsWith('//') ? `https:${src}` : String(src);
    return `${u}${u.includes('?') ? '&' : '?'}width=${w}`;
  };

  function card(p, root) {
    const li = document.createElement('li');
    li.className = 'bmp-rv__item';
    const a = document.createElement('a');
    a.className = 'bmp-rv__card';
    a.href = `${root}products/${p.handle}`;
    const media = document.createElement('div');
    media.className = 'bmp-rv__img';
    if (p.featured_image) {
      const img = document.createElement('img');
      img.src = sized(p.featured_image, 600);
      img.srcset = [300, 450, 600, 800].map((w) => `${sized(p.featured_image, w)} ${w}w`).join(', ');
      img.sizes = '(max-width: 749px) 38vw, 280px';
      img.loading = 'lazy';
      img.alt = p.title;
      img.width = 600;
      img.height = 750;
      media.append(img);
    }
    const t = document.createElement('p');
    t.className = 'bmp-rv__t';
    t.textContent = p.title;
    const pr = document.createElement('span');
    pr.className = 'bmp-rv__p';
    pr.textContent = `${p.price_varies ? 'From ' : ''}${money(p.price_min ?? p.price)}`;
    a.append(media, t, pr);
    li.append(a);
    return li;
  }

  async function init(section) {
    if (section.dataset.bmpRvInit) return;
    section.dataset.bmpRvInit = '1';
    const current = section.dataset.current || '';
    const root = section.dataset.root || '/';
    const prior = read().filter((h) => h !== current);
    // Record this view (newest first) before rendering the others.
    if (current) write([current, ...prior]);

    const track = section.querySelector('[data-bmp-rv-track]');
    section.querySelector('[data-bmp-rv-clear]')?.addEventListener('click', (e) => {
      e.preventDefault();
      try { localStorage.removeItem(KEY); } catch {}
      track.replaceChildren();
      section.hidden = true;
    });
    if (!prior.length || !track) return;

    const results = await Promise.all(prior.slice(0, MAX_STORED).map((h) =>
      fetch(`${root}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { gone: h }))
        .catch(() => null)));
    // Forget products that no longer exist.
    const gone = results.filter((r) => r && r.gone).map((r) => r.gone);
    if (gone.length) write(read().filter((h) => !gone.includes(h)));

    const products = results.filter((p) => p && !p.gone && p.handle && p.available !== false).slice(0, MAX_SHOWN);
    if (!products.length) return;
    track.replaceChildren(...products.map((p) => card(p, root)));
    section.hidden = false;
  }

  const run = () => document.querySelectorAll('[data-bmp-rv]').forEach((s) => { init(s).catch((e) => console.warn('[bmp-rv]', e)); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
// BMP-HOOK-END:recently-viewed
